import { useState, useEffect } from 'react'

export const useFetchOperationDetail = ({ marvarApi, dispatch, onLogout, paramsURL }) => {
    
    const { idoperacion } = paramsURL

    const [ dataOperationDetail, setDataOperationDetail ] = useState([])

    const [ loadingFetchOperationDetail, setLoadingFetchOperationDetail ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataOperationDetail([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/cashier-operations/operation-detail/${idoperacion}`)
            // console.log('[useFetchData][useFetchOperationDetail] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchOperationDetail(true)
        fetchData()
            .then((resp) => {
                setDataOperationDetail(resp.rows)
                setLoadingFetchOperationDetail(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchOperationDetail(false)
            })
    }, [execute])

    return { dataOperationDetail, loadingFetchOperationDetail, executeFetch, resetFetch }
}

export const useFetchSpecificOperation = ({marvarApi, dispatch, onLogout, paramsURL}) => {

    const { idoperacion } = paramsURL

    const _defaultParams = {
        idoperacion: ''
    }
    
    const [ dataSpecificOperation, setDataSpecificOperation ] = useState([])

    const [ loadingFetchSpecificOperation, setLoadingFetchSpecificOperation ] = useState(false)

    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/cashier-operations/fetch-specific-operation/${idoperacion}`)
            // console.log('[useFetchData][useFetchSpecificOperation] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchSpecificOperation(true)
        fetchData()
            .then((resp) => {
                
                // Setea en el estado del formulario los datos del registro
                const { rows } = resp
                setDataSpecificOperation(rows)
                setLoadingFetchSpecificOperation(false)

            })
            .catch(e => {
                console.log(e, '________ERROR')
                setDataSpecificOperation([])
                setLoadingFetchSpecificOperation(false)
            })
    }, [execute])

    return { dataSpecificOperation, loadingFetchSpecificOperation, setParamsToSearch, executeFetch }

}

export const useFetchModulos = ({ marvarApi, dispatch, onLogout }) => {

    const [ dataModulos, setDataModulos ] = useState([])

    const [ loadingFetchModulos, setLoadingFetchModulos ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataModulos([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/cashier-operations/modulos`)
            // console.log('[useFetchData][useFetchModulos] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchModulos(true)
        fetchData()
            .then((resp) => {
                setDataModulos(resp.rows)
                setLoadingFetchModulos(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchModulos(false)
            })
    }, [execute])

    return { dataModulos, loadingFetchModulos, executeFetch, resetFetch }
}

export const useFetchSecciones = ({ marvarApi, dispatch, onLogout }) => {

    const _defaultParams = {
        idmodulo: '',
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ dataSecciones, setDataSecciones ] = useState([])

    const [ loadingFetchSecciones, setLoadingFetchSecciones ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataSecciones([])
        setParamsToSearch(_defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/cashier-operations/secciones/${paramsToSearch.idmodulo}`,)
            // console.log('[useFetchData][useFetchSecciones] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (
            paramsToSearch.idmodulo > 0 
            && paramsToSearch.idmodulo !== ''
        ) {
            setLoadingFetchSecciones(true)
            fetchData()
                .then((resp) => {
                    setDataSecciones(resp.rows)
                    setLoadingFetchSecciones(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSecciones(false)
                })
        }
    }, [execute])

    return { dataSecciones, loadingFetchSecciones, setParamsToSearch, executeFetch, resetFetch }
}